<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('UPDATE_SUBSCRIPTION.TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      // tenant
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('UPDATE_SUBSCRIPTION.TENANTNAME')}}
        v-col.pa-0
          v-select(
            v-model='selectTanent',
            outlined,
            :items='tenantListItems',
            :rules='formRule.tenantRules',
            item-text='name',
            item-value='name',
            :placeholder=`$t('UPDATE_SUBSCRIPTION.SELECT_TENANT')`,
            dense,
            required='required',
            :disabled='addBtn_loading'
            )
      // subscription date
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('UPDATE_SUBSCRIPTION.SUBSCRIPTION')}}
        v-col.pa-0
          v-menu(
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          )
            template(v-slot:activator="{ on, attrs }")
              v-text-field.pt-0(
                :title='selectDateText'
                v-model='selectDateText'
                class="no-bold-text"
                v-bind="attrs"
                v-on="on"
                flat
                dense
                outlined
                background-color="white"
                prepend-inner-icon='mdi-calendar'
              )
            v-date-picker(
                v-model='selectDate'
                @input="updateDate"
                no-title
                type="date"
                :showSecond='false'
                value-type='format'
                format='YYYY-MM-DD'
            )
    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
      v-btn.mr-4(
        :ripple="false",
        @click="onCancel",
        width="100",
        height="40",
        color="cancel",
        depressed,
        outlined,
        style='font-weight: 700;'
        :disabled='addBtn_loading'
      ) {{$t('GENERAL.CANCEL')}}
      v-btn.mr-6(
        :ripple="false",
        @click="onConfirm",
        width="100",
        height="40",
        color="#14C6DE",
        depressed,
        dark,
      ) 
        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('TENANTCENTER.CREATE')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
    success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
</template>

<script>
import Vue from "vue";
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import successDialog from "@/components/Dialog/successDialog";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";


export default Vue.extend({
  props: {
    tenantListItems: {
      type: Array,
      require: true,
    },
  },
  components: {            
      messageDialog,
      errorDialog,
      successDialog
  },
  data() {
    return {
      selectDateText: '',
      selectDate:'',
      menu: false,
      addBtn_loading:false,
      addData : {},
      messageDialog:false,
      message:"",
      errorDialog: false,
      errorMessage: "",
      successDialog: false,
      valid: true,
      formRule: {
        tenantRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') ,
        ],
      },
      enterTenant:"",
      tenantList:[],
      passwordType: "password",
      iconType:"fa fa-eye-slash",
      selectTanent:""
    };
  },
  async created(){
  },
  methods: {
    updateDate(val) {
      this.selectDateText = val;
    },
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    async onConfirm() {
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        this.addData.end_date = this.selectDate;
        this.addData.schema_name = this.selectTanent;
        console.log('this.addData', this.addData)
        TenantCenterService.updateSubscription(this.addData).then(()=>{
          this.showSuccessDialog();
        })
        .catch(error => {
          let error_msg = error.response.data.error
          this.showErrorDialog(error_msg);
        })

      }
    },
    onCancel() {     
      this.$emit("emitUpdateSubscriptionDialog", false);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog(val) {
      if(val){
        // 
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      this.addBtn_loading = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    async onEmitSuccessDialog() {
      this.$emit("emitUpdateSubscriptionDialog", false);
      this.successDialog = false;
    },
  },
});
</script>